/**
 * Ordena uma lista de faturas pelo valor de boletoVeins.
 * @param {PanoramaInvoice[]} invoices - A lista de faturas.
 * @param {string} property - O mês que deve ser usado para ordenar. Valores possíveis: 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'.
 * @param {boolean} ascending - Se true, ordena de forma ascendente, se false, de forma descendente.
 * @returns {PanoramaInvoice[]} - A lista ordenada de faturas.
 */

export function sortPanoramaInvoiceByBoletoVeins(
  invoices,
  property,
  ascending = true,
) {
  const rawKey = property.replace('InvoiceData', ''); // ex.: "012025"
  return invoices.sort((a, b) => {
    const aFound = a.invoicesData.find(inv => inv.key === rawKey);
    const bFound = b.invoicesData.find(inv => inv.key === rawKey);
    const aValue = aFound ? aFound.boletoVeins : 0;
    const bValue = bFound ? bFound.boletoVeins : 0;

    if (ascending) {
      return aValue - bValue;
    } else {
      return bValue - aValue;
    }
  });
}
